export enum ApiUserRole  {

     // Pour le moment on gère par rôle imbriqués en utilisant des demi-octets (4 bits) pour chaque rôle de manière à pouvoir
     // granulariser les permissions par la suite

     // bits 0..3	--> persimmsions de Visiteur (non granularisées)
     // bits 4..7	--> persimmsions Client (non granularisées)
     // bits 8..11	--> persimmsions Reception (non granularisées)
     // bits 12..15	--> persimmsions RoomService (non granularisées)
     // bits 16..19	--> persimmsions d'administration (non granularisées)
     // bits 20..23	--> persimmsions root (non granularisées)

     CentralWeb		= "CentralWeb",     // (2 << 24) -1,	// 1111 1111 1111 1111 1111 1111
     Admin			= "Admin",          // (2 << 20) -1,	// 0000 1111 1111 1111 1111 1111
     RoomService		= "RoomService",    // (2 << 16 ) -1,	// 0000 0000 1111 1111 1111 1111
     Reception		     = "Reception",      //(2 << 12) - 1,    // 0000 0000 0000 1111 1111 1111		
     Client			= "Client",         // (2 << 4) - 1,    // 0000 0000 0000 0000 1111 1111
     Visiteur		     = "Visiteur",       // (2 <<  4) -1,	// 0000 0000 0000 0000 0000 1111
} 